<template>
    <div>
        <official-factor-filter
                :actionAllUsers="exportExcelAllUsers" :action="filterAction" >
        </official-factor-filter>
        <user-reports-official-factor
                v-if="status === 'success'" :officialFactor="officialFactor" :query="query">
        </user-reports-official-factor>
    </div>
</template>
<script>

import OfficialFactorFilter from "./official-factor-filter";
import userReportsOfficialFactor from "./user-reports-official-factor";
import {mapGetters} from "vuex";
import $ from "jquery";
import axios from "axios";
import { ApiUrl } from '@/common/api.service'
import { i18n } from '@/plugins/i18n'
import toastr from "toastr";

export default {
    components: { OfficialFactorFilter,
        'user-reports-official-factor': userReportsOfficialFactor
    },

    data() {
       return {
           query: {},
       }
    },

    computed: {
        ...mapGetters('reports', [
            'officialFactor', 'status'
        ]),
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        }
    },

    methods: {
        filterAction(e, q) {
            this.query = {
                'query': q
            }

            let form = $('#official_factor_form')
            form.validate({
                rules: {
                    month: {
                        required: true,
                    },
                    year: {
                        required: true,
                    }
                }
            })

            if(!form.valid()) {
                return
            }
            this.$store.dispatch('reports/fetchUserOfficialFactor', this.query)
        },
        exportExcelAllUsers(e, query) {
            $('.loader').addClass('disp_block')

            axios ({
                url: ApiUrl.path('reports/admin/factor-excel-export-all-users'),
                method: 'GET',
                params: {
                    'query' : query
                },
            })
                .then(
                    response => {
                        $('.loader').removeClass('disp_block')
                        var fileLink = document.createElement('a');
                        fileLink.href = response.data.data;
                        fileLink.setAttribute('download', 'official-factor.zip');
                        document.body.appendChild(fileLink);

                        fileLink.click();
                    }
                )
                .catch( ({response}) => {
                    $('.loader').removeClass('disp_block')
                    this.toastr.error(response.data.message)
                })
        }
    },

    mounted() {
        this.$store.dispatch('reports/fetchUserOfficialFactor', this.query)
    }
}
</script>